import React from "react";
import styled from "styled-components";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

const ReactTable2 = ({ data, columns }) => {
  return (
    <TableWrapper>
      <StyledTable>
        <Thead>
          <Tr>
            {columns.map((col, idx) => (
              <StyledTh key={idx}>{col.header}</StyledTh>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {data.map((row, rowIndex) => (
            <StyledTr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <StyledTd key={colIndex}>
                  {col.cell ? col.cell(row) : row[col.accessorKey] ?? "-"}
                </StyledTd>
              ))}
            </StyledTr>
          ))}
        </Tbody>
      </StyledTable>
    </TableWrapper>
  );
};

export default ReactTable2;

/* 🎨 Sadece kullanılan stiller */

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 1rem;

  @media (max-width: 768px) {
    padding-right: 0rem;
  }
`;

const StyledTable = styled(Table)`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const StyledTh = styled(Th)`
  background-color: var(--main-color) !important;
  color: #fff !important;
  text-align: center !important;
  padding: 12px !important;
  font-weight: bold !important;
  border: none !important;
`;

const StyledTd = styled(Td)`
  text-align: center !important;
  padding: 10px !important;
  border-bottom: 1px solid #ddd !important;
  background: white !important;

  @media (max-width: 768px) {
    text-align: left !important;
    border-bottom: none !important;
    padding: 8px !important;
  }
`;

const StyledTr = styled(Tr)`
  &:nth-child(even) {
    background-color: var(--third-color) !important;
  }
`;
